import React from 'react';
import { DialogBody, DialogStyled, DialogTitle } from './index.styled';
import { TDialog } from './index.types';

const Dialog: React.FC<TDialog> = ({
    className,
    isDialogOpen,
    setIsDialogOpen,
    children,
    title,
}) => {
    return (
        <DialogStyled
            className={className}
            onClose={() => setIsDialogOpen(false)}
            aria-labelledby="dialog"
            open={isDialogOpen}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogBody>{children}</DialogBody>
        </DialogStyled>
    );
};

export default Dialog;
